export default __webpack_public_path__ + "static/media/TriTech.1a35a375.svg";